<div id="acom">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class=" inner-card">
                    <h4 class="card-title ">Academic Block</h4>
                    <div class="card-body text-justify">
                      <p class="inner-lead">The School has three floors with 86 Classrooms, well equipped laboratories for Physics, Chemistry, Biology, Maths, Self- management, a well stocked library ,Music rooms a Gymnasium and two multipurpose halls, spacious parking.</p>
                      <p class="inner-lead">The classrooms are big and well lit and ventilated, which can accommodate the ideal strengths prescribed by the CBSE.</p>
                      <p class="inner-lead">Walls of the corridor are adorned with display boards regularly maintained by students and teachers of different Houses turn wise.</p>
                            <div id="academicCarousel" class="carousel slide" data-ride="carousel">
                              <div class="carousel-indicators">
                                <button type="button" data-bs-target="#academicCarousel" *ngFor="let img of imgUrl, let i = index" class="{{ (i == 0) ? 'active' : '' }}" data-bs-slide-to="0" aria-current="true" aria-label="Slide 1"
                                attr.data-bs-slide-to="{{i}}"></button>
                              </div>
                                <div class="carousel-inner text-center py-5 px-3">
                                  <div class="carousel-item" *ngFor="let img of imgUrl, let i=index" [ngClass]="(i == 0 ) ? 'active' : ''">
                                    <a appLazyload href="{{img}}" data-lightbox="Academic"><img appLazyload [src]="img" alt="Academic" class="img-fluid rounded"></a>
                                  </div>
                                </div>
                                <button class="carousel-control-prev" type="button" data-bs-target="#academicCarousel" data-bs-slide="prev">
                                  <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                  <span class="visually-hidden">Previous</span>
                                </button>
                                <button class="carousel-control-next" type="button" data-bs-target="#academicCarousel" data-bs-slide="next">
                                  <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                  <span class="visually-hidden">Next</span>
                                </button>
                              </div>
                    </div>
                </div>

            </div>
        </div>

       
    </div>
</div>